<template>
  <div
    @click="$store.commit('modals/OPEN_PRODUCT_POPUP', false)"
    class="md-pd flex items-center w-full h-full justify-center add-product__modal__container"
  >
    <section
      @click.stop
      class="w-full p-3 md:p-6 add-product__modal__container__chat max-w-3xl relative mx-0 md:mx-10 md:my-2 py-4 md:py-8"
    >
      <div
        @click="$store.commit('modals/OPEN_PRODUCT_POPUP', false)"
        class="flex absolute items-center justify-center cross-icon cursor-pointer z-20"
      >
        X
      </div>

      <div class="w-full flex">
        <!-- <div class="w-full flex justify-evenly gap-x-2">
          <p
            :class="[
              this.frame === 'details'
                ? 'product__tabs product__tabs__selected'
                : 'product__tabs',
            ]"
            @click="setFrame('details')"
          >
            Details
          </p>
          <p
            :class="[
              this.frame === 'update'
                ? 'product__tabs product__tabs__selected'
                : 'product__tabs',
            ]"
            @click="setFrame('update')"
          >
            Update
          </p>
        </div> -->
        <section class="w-2/5 md:w-1/2">
          <p class="text-sm text-left lg:ml-3">Product Image(s) :</p>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-1">
            <div
              v-for="(image, index) in product.product_images"
              :key="index"
              class="rounded-lg items-start m-1 lg:m-3 w-32 h-32 lg:w-64 lg:h-64 flex justify-center mb-2 p-2 border border-gray"
            >
              <img :src="image" class="h-full w-full object-cover" />
            </div>
          </div>
        </section>
        <section class="w-3/5 md:w-1/2 flex flex-col justify-between ml-2 md:ml-6 pl-4">
          <div>
            <div class="flex flex-col gap-y-1 lg:gap-y-4 text-left">
              <!-- Product Name -->
              <!-- <h4 class="text-2xl uppercase">
                {{ product.product_name }}
              </h4> -->
              <!-- Product Description -->
              <!-- <p class="text-sm">{{ product.product_brief }}</p> -->
              <div>
                <label class="text-xs md:text-sm text-left">Product Name</label>
                <input
                  type="text"
                  id="product-name"
                  class="rounded-lg p-3 border-2 border-gray w-full"
                  v-model="productName"
                />
              </div>

              <div class="product__name">
                <label class="text-xs md:text-sm text-left">Product Description</label>
                <vs-textarea
                  id="product-description"
                  class="border-2 border-gray rounded-lg w-full"
                  rows="5"
                  v-model="productBrief"
                ></vs-textarea>
              </div>
            </div>

            <div class="flex flex-col w-full gap-y-1 lg:gap-y-4">
              <div class="flex flex-row items-center justify-center">
                <!-- Product Price -->

                <!-- <div class="flex flex-row gap-x-2 justify-center items-center w-[20%] self-center border-gray border-2 rounded-lg p-3 px-5">
                <p class="text-xl flex-3 ">{{ product.product_price }}</p>
                <p class="text-xl text-left flex-2 ">
                  {{
                    orgPriceTypes.filter(
                      (price) => price.key == product.product_price_type
                    )[0]
                      ? orgPriceTypes.filter(
                          (price) => price.key == product.product_price_type
                        )[0].label || ""
                      : ""
                  }}
                </p>
              </div> -->
                <!-- Inventory Count and Orders Placed -->
                <!-- <div class="flex flex-row gap-x-2 items-center self-center justify-center w-[47%] border-gray border-2 rounded-lg p-3">
                <p class="text-xl text-left ">Inventory Count</p>
                <p class="text-xl ">{{ product.in_store }}</p>
              </div> -->
              </div>

              <!-- Inventory Counter -->
              <div class="flex flex-col justify-start">
                <label class="text-xs md:text-sm text-left">Inventory Count</label>
                <input
                  type="number"
                  id="product-stock"
                  class="border-2 border-gray rounded-lg p-3 w-full text-xl"
                  v-model="productInStock"
                />
              </div>

              <!-- Price Price Type -->
              <div class="w-full grid grid-cols-1 md:grid-cols-2 gap-1 md:gap-3">
                <div class="flex flex-col items-start">
                  <label class="text-xs md:text-sm text-left">Product Price</label>
                  <input
                    type="number"
                    id="product-price"
                    v-model="productPrice"
                    class="border-2 border-gray rounded-lg p-3 w-full"
                    placeholder="Price"
                  />
                </div>
                <div class="flex flex-col items-start">
                  <label class="text-xs md:text-sm text-left">Price Type</label>
                  <vs-select
                    id="priceType"
                    name="product-price"
                    class="w-full flex flex-col"
                    placeholder=""
                    v-model="selectedPriceType"
                  >
                    <option
                      v-for="price in orgPriceTypes"
                      :key="price.key"
                      :value="price.label"
                      @click="setSelectedPriceType(price.key)"
                      class="cursor-pointer py-1 bg-gray"
                    >
                      {{ price.label || "" }}
                    </option>
                  </vs-select>
                </div>
              </div>
            </div>
          </div>
          <!-- Update Delete -->
          <div
            class="flex flex-col md:flex-row gap-2 my-2 mb-2 w-full h-1/2 items-center justify-end"
          >
            <vs-button
              @click="updateProduct()"
              class="w-full lg:w-1/4 rounded-lg"
            >
              Update
            </vs-button>
            <button
              @click="deleteProduct()"
              class="w-full lg:w-1/4 border-none delete-btn p-3 rounded-lg"
            >
              Delete
            </button>
          </div>

          <!-- <div class="flex">
              <div class="flex flex-col gap-y-2 ml-4">
                <p class="text-sm">Orders Placed</p>
                <p class="text-2xl">{{ product.orders_placed }}</p>
              </div>
            </div> -->
        </section>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "AddProductTypeModal",
  data() {
    return {
      frame: "details", // details | update
      productType: "",
      productBrief: "",
      productInStock: "",
      productPrice: "",
      productName: "",
      updateFileViews: [],
      updateFiles: [],
      selectedPriceType: "",
      selectedPriceTypeIndex: 1,
    };
  },
  props: {
    active: Boolean,
    product: Object,
    userId: String,
    orgId: {
      required: true,
      type: String,
    },
  },
  computed: {
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    orgProductTypes() {
      return this.$store.state.market.orgProductTypes;
    },
    orgPriceTypes() {
      return this.$store.state.market.orgPriceTypes;
    },
    defaultPriceType() {
      if (this.product.product_price_type) {
        const matchingPriceType = this.orgPriceTypes.find(
          (price) => price.key === this.product.product_price_type
        );
        return matchingPriceType ? matchingPriceType.label : null;
      }
      return null;
    },
  },
  mounted() {
    if (this.product && this.product.in_store !== undefined) {
      this.productInStock = this.product.in_store;
    }
    if (this.defaultPriceType !== null && this.defaultPriceType !== undefined) {
      this.selectedPriceType = this.defaultPriceType;
    }
    // this.selectedPriceType = this.orgPriceTypes[this.defaultPriceType].label;
    if (this.product && this.product.product_price !== undefined) {
      this.productPrice = this.product.product_price;
    }
    if (this.product && this.product.product_name !== undefined) {
      this.productName = this.product.product_name;
    }
    if (this.product && this.product.product_brief !== undefined) {
      this.productBrief = this.product.product_brief;
    }
  },
  methods: {
    setProductType(productType) {
      this.productType = productType;
    },

    capitalizeFirstLetter(string) {
      return string
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
    },
    close() {
      this.$store.commit("modals/OPEN_PRODUCT_POPUP", false);
    },
    setFrame(frame) {
      this.frame = frame;
    },
    setSelectedPriceType(_value) {
      this.selectedPriceType = this.orgPriceTypes.filter(
        (price) => price.key === _value
      )[0].label;
      this.selectedPriceTypeIndex = _value;
    },
    getBase64Image(imageData) {
      return `data:image/jpeg;base64,${imageData}`;
    },
    updateProduct() {
      this.$vs.loading();
      const accessToken = localStorage.getItem("accessToken");
      if (this.productName === "") {
        this.productName = this.product.product_name;
      }
      if (this.productBrief === "") {
        this.productBrief = this.product.product_brief;
      }
      if (this.productInStock === "") {
        this.productInStock = this.product.in_store;
      }
      if (this.productPrice === "") {
        this.productPrice = this.product.product_price;
      }
      if (this.selectedPriceType === "") {
        this.selectedPriceType =
          this.orgPriceTypes[this.product.product_price_type].label || "";
        this.selectedPriceTypeIndex = this.product.product_price_type;
      }
      const formData = {
        product_name: this.productName,
        product_price: this.productPrice.toString(),
        product_brief: this.productBrief,
        in_store: this.productInStock.toString(),
        product_price_type: this.selectedPriceTypeIndex,
      };

      const payload = {
        formData,
        id: this.product._id,
        orgId: this.orgId,
        userId: this.userId,
        accessToken: accessToken,
      };

      this.$store
        .dispatch("organization/updateProduct", payload)
        .then((message) => {
          this.$parent.fetchProducts();
          this.close();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Upating Product",
            text: message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Updating Product",
            text: error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    deleteProduct() {
      this.$vs.loading();
      const accessToken = localStorage.getItem("accessToken");
      const payload = {
        orgId: this.orgId,
        id: this.product._id,
        userId: this.userId,
        accessToken,
      };
      this.$store
        .dispatch("organization/deleteProduct", payload)
        .then((message) => {
          this.$parent.fetchProducts();
          this.close();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Deleting Product",
            text: message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Deleting Product",
            text: error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
  },
  watch: {
    active(newVal) {
      if (newVal) {
        this.productType = "";
        this.productBrief = "";
        this.productInStock = "";
        this.productPrice = "";
      }
    },
  },

  // mounted() {
  //   console.log("orgId pm", this.orgId);
  // },
};
</script>

<style lang="scss" scoped>
.bg-gray:hover {
  background-color: #f7f7f7;
  // border-color: #D2D3D3;
}
.delete-btn:hover {
  background-color: #d3d3d3;
  cursor: pointer;
}
.border-none {
  border: none !important;
}
.border-gray {
  border: 2px solid #d2d3d3;
  // border-color: #D2D3D3;
}
.scrollbarWidth::-webkit-scrollbar {
  width: 10px;
}
.scrollbarWidth::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(41, 39, 39, 0.3);
  border-radius: 10px;
}
.scrollbarWidth::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 20px rgb(193, 193, 193);
}

.preview_images {
  width: 40px !important;
  height: 40px !important;
}
.vs-con-textarea {
  margin-bottom: 0 !important;
}

.product__tabs {
  width: 100%;
  border-radius: 0px;
  padding-bottom: 4px;
  // border-color: purple;

  &:hover {
    border-color: #fd0;
    cursor: pointer;
  }
}

.product__tabs__selected {
  border-bottom: 2px solid #fd0;
  cursor: pointer;
}
.cross-icon {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  top: 0;
  font-size: 1.5em;
  padding: 0.5em;
  border-radius: 50%;
  height: 2em;
  width: 2em;
  top: -0.5em;
  right: -0.5em;
  transition: all 0.23s ease 0.1s;
  transform: translate(8px, -2px);
  font-family: "Montserrat", Helvetica, Arial, serif;
  background: #fffffffa;
  // For hover effect of close btn
  &:hover,
  &:focus,
  &:active {
    opacity: 1;
    outline: none;
    transform: translate(5px, 3px);
    box-shadow: none;
  }
}
.skeleton {
  position: relative;
  margin: 2em 0;
  padding: 10em 0;
  border-radius: 10px;
  background: rgb(128, 128, 128);
  animation: flicker-light 1s infinite alternate;
}
@keyframes flicker-light {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
}
.b-dropdown ::v-deep .dropdown-toggle {
  white-space: normal;
}

.add-product__modal {
  &__container {
    background: #0000006a;
    backdrop-filter: blur(5px);
    position: fixed !important;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 100000;
    &__chat {
      max-height: 38.75rem;
      width: 100%;
      border-radius: 10px;
      background: #fff;
      .text {
        color: #1c1c1e;
      }
    }

    .vs-tooltip {
      z-index: 5200000;
    }
    .card {
      background: #ffffff;
      box-shadow: 6px 6px 29px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
    }
    .validate-btn {
      font-size: 1.2em;
      background: grey;
      color: #fff;
      border-radius: 10px;
    }
    .validate-icon {
      filter: invert(91%) sepia(34%) saturate(1988%) hue-rotate(321deg)
        brightness(99%) contrast(92%);
    }
    .choose-skill__chat {
      width: 25%;
      max-height: 27.5em;
      height: auto;
      // top: 17.5%;
    }

    .choose-skill {
      &__avatar {
        // width: 100%;
      }
      &__btns {
        .btn {
          padding: 1em;
          background-color: #82868b;
          color: #ffffff;
          width: 55%;
        }
      }
    }

    .overflow-container {
      max-height: 25em;
      overflow-y: scroll;
    }
  }
}

@media only screen and (max-width: 1400px) {
  .add-product__modal {
    &__container {
      .choose-skill {
        &__btns {
          .btn {
            width: 70%;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .add-product__modal {
    &__container {
      .choose-skill {
        &__chat {
          right: 2.75em;
          width: 32%;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .add-product__modal {
    &__container {
      &__chat {
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .add-product__modal {
    &__container {
      .choose-skill {
        &__chat {
          width: 50%;
          max-height: 75%;
          height: auto;
        }
      }
    }
  }
}

@media only screen and (max-width: 660px) {
  .add-product__modal {
    &__container {
      // &__chat {
      //   width: 95%;
      //   height: 75%;
      //   top: 3.5em;
      // }

      .choose-skill__chat {
        width: 95%;
      }
      .choose-skill {
        &__avatar {
          img {
            width: 25%;
          }
        }
      }
    }
  }
}
</style>
